import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { propMatch } from '@/helpers/custom-prop-types';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { apiGetOneFreeProfessional } from '../../../actions/ProfessionalActions';
import { FORBIDDEN, NOT_FOUND } from '../../../define/response';
import { wrapDispatch } from '../../../helpers/action';
import { relationFilterByFree, sortByDate, } from '../../../helpers/common/ProfessionalInformationHelper';
import ForbiddenOne from '../../Forbidden/ForbiddenOne';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import { CurrentProcessLoader } from '../../Ui/Loading';
import PdfImageModal from '../../Ui/Modal/Pdf/PdfImageModal';
import AboutContents from './Parts/AboutContents/AboutContents';
import AboutProfile from './Parts/AboutProfile';
const FreeProfessionalOne = (props) => {
    const { match: { params: { id }, }, } = props;
    const history = useNavigate();
    const dispatch = useDispatch();
    const [isForbidden, changeIsForbidden] = useState(false);
    const professional = useSelector((state) => state.professional[id] || null);
    const baseSkillsCandidates = useSelector((state) => state.category.baseSkills || []);
    useEffect(() => {
        let isExit = false;
        changeIsForbidden(false);
        wrapDispatch(dispatch, apiGetOneFreeProfessional(id, { id }))
            .then()
            .catch((e) => {
            if (isExit) {
                return;
            }
            if (e.code === NOT_FOUND) {
                history.push('/');
            }
            else if (e.code === FORBIDDEN) {
                changeIsForbidden(true);
            }
        });
        return () => {
            isExit = true;
        };
    }, [history, dispatch, id]);
    const { assignable, baseSkills, careers, description, experienceList, experiencedIndustryClasses, file, middleTasks, onSite, overview, portfolios, projectCareers, situation, unitTime, userId, } = useMemo(() => {
        const information = _.get(professional, 'information');
        const freeInformation = _.get(professional, 'freeInformation');
        return {
            assignable: _.get(freeInformation, 'assignable'),
            baseSkills: baseSkillsCandidates.filter(relationFilterByFree).map((v) => {
                const userBaseSkill = (_.get(information, 'baseSkills') || []).find((userValue) => userValue.id === v.id);
                return Object.assign(Object.assign({}, v), { level: _.get(userBaseSkill, 'level') || 5 });
            }),
            careers: sortByDate(information, 'careers'),
            description: _.get(information, 'description'),
            experienceList: _.get(information, 'experiences'),
            experiencedIndustryClasses: _.get(information, 'experiencedIndustryClasses'),
            file: _.get(information, 'file'),
            middleTasks: (_.get(information, 'middleTasks') || []).filter(({ especially }) => especially),
            onSite: _.get(freeInformation, 'onSite'),
            overview: _.get(freeInformation, 'overview'),
            portfolios: _.get(freeInformation, 'relatedPortfolios') || [],
            projectCareers: sortByDate(information, 'projectCareers'),
            situation: _.get(information, 'situation'),
            unitTime: _.get(freeInformation, 'unitTime'),
            userId: _.get(freeInformation, 'nominalNumber'),
        };
    }, [professional, baseSkillsCandidates]);
    if (isForbidden) {
        return (_jsx(ForbiddenOne, { text: '他社のコンサルタントの方の情報はノウハウを保護するため、開示できません。' }));
    }
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main layout_consultant_one bg-about is-free' }, { children: [professional ? (_jsxs("div", Object.assign({ className: 'l-about is-view' }, { children: [_jsx(AboutProfile, { assignable: assignable, experiencedIndustryClasses: experiencedIndustryClasses, experienceList: experienceList, file: file, onSite: onSite, situation: situation, unitTime: unitTime, userId: userId }), _jsx(AboutContents, { baseSkills: baseSkills, careers: careers, description: description, middleTasks: middleTasks, overview: overview, portfolios: portfolios, projectCareers: projectCareers })] }))) : (_jsx(CurrentProcessLoader, { marginTop: 30 })), _jsx(PdfImageModal, {})] })));
};
FreeProfessionalOne.propTypes = {
    match: propMatch(),
};
export default AuthenticationHoc({
    isMember: true,
    isPreClient: false,
    notPreClientRedirectTo: '/mypage',
})(FreeProfessionalOne);
